import { PureComponent, type ReactNode } from 'react';

import classNames from 'classnames';

import { ui } from '../../utils/helpers';

import styles from './collection_keyframes.module.css';

type Props = {
  source?: string;
  className?: string;
};

type State = {
  updated?: string;
};

class CollectionKeyframe extends PureComponent<Props, State> {
  state: State = {};

  componentDidUpdate(prevProps: Readonly<Props>): void {
    if (this.props.source !== prevProps.source) {
      this.update();
    }
  }

  update(): void {
    this.setState((_state, props) => ({ updated: props.source }));
  }

  render(): ReactNode {
    const { className, source } = this.props;
    const { updated } = this.state;
    if (!source) {
      return '';
    }
    return (
      <div
        className={classNames(
          styles.keyframe,
          className,
          !source ? styles.empty : undefined,
        )}
      >
        <div
          key={source}
          role="img"
          aria-label="Collection keyframe"
          {...ui('image')}
          style={{ backgroundImage: `url(${source})` }}
          className={classNames(styles.image, updated ? styles.new : undefined)}
        />
      </div>
    );
  }
}

export default CollectionKeyframe;
